import { Grid, Tabs, Tab, Paper } from "@material-ui/core";
import React, { Component } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import shortfetch from "../../components/data/fetch";
import LoadingBar from "../../components/data/loading";
import { DataGrid } from "@material-ui/data-grid";

class StatisticalOverview extends Component {
  data_array = [];
  rawData = [];
  select_items_list = [];
  ERGINGIETSFOUT = [];
  SpendPerYearArray = [];

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selected: 3,

      sortModel: [{ field: "value", sort: "desc" }],
      prevSortModel: [],
      selectionModel: [],
    };
  }

  async fetch_data() {
    let post_json = {
      type: "data_statiscial_overview",
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);
    console.log("fetched_data", data.data_array);

    this.data_array = data.data_array;
    this.SpendPerYearArray = data.SpendPerYear;
    console.log(this.SpendPerYearArray);

    post_json = {
      id: 1,
      type: "model_data",
      auth: localStorage.getItem("auth"),
    };

    data = await shortfetch(post_json);

    this.select_items_list = data;

    this.prepare_data();
  }

  prepare_data() {
    let preparedData = [];

    this.data_array.forEach((model) => {
      if (!preparedData.some((item) => item.name == model.naam)) {
        preparedData.push({
          id: model.FabrikantID,
          name: model.naam,
          value: 0.0,
          selected: true,
          aantal: 0,
        });
      }

      const Nieuwwaarde = Math.round(
        parseFloat(model.Nieuwwaarde.replace(",", ".")),
        2
      );
      const InkoopModel = Math.round(
        parseFloat(model.InkoopModel.replace(",", ".")),
        2
      );

      preparedData.forEach((fabrikant) => {
        if (
          (Nieuwwaarde == 0 || InkoopModel == 0) &&
          fabrikant.name == model.naam
        ) {
          fabrikant.value += Nieuwwaarde;
          fabrikant.value += InkoopModel;
          fabrikant.aantal += 1;

          model.value = Nieuwwaarde + Nieuwwaarde;
        }
        if (
          !this.ERGINGIETSFOUT.includes(model.ModelID) &&
          Nieuwwaarde != 0 &&
          InkoopModel != 0 &&
          fabrikant.name != model.naam
        ) {
          this.ERGINGIETSFOUT.push(model.ModelID);
        }
        if (
          Nieuwwaarde == 0 &&
          InkoopModel == 0 &&
          !this.ERGINGIETSFOUT.includes(model.ModelID)
        ) {
          this.ERGINGIETSFOUT.push(model.ModelID);
        }
      });
    });

    // console.log("HIER GING IETS FOUT", this.ERGINGIETSFOUT);
    // console.log(preparedData);

    preparedData.forEach((element) => {
      if (element.value <= 50) {
        element.selected = false;
      }
    });

    const filteredData = this.rawData.filter((item) => item.selected == true);

    let selectionModel = [];
    filteredData.forEach((element) => {
      selectionModel.push(element.id);
    });

    filteredData.sort(function (a, b) {
      return b.value - a.value;
    });

    this.rawData = preparedData;
    this.setState({
      filteredData: filteredData,
      isLoading: false,
      selectionModel: selectionModel,
    });
  }

  handleSelectionChange = (selectionModel) => {
    const filteredData = this.rawData.filter((item) =>
      selectionModel.includes(item.id)
    );

    filteredData.sort(function (a, b) {
      return b.value - a.value;
    });

    this.setState({
      selectionModel: selectionModel,
      filteredData: filteredData,
    });
  };

  handleSortChange = (sortModel) => {
    // console.log(
    //   "vorige state",
    //   this.state.sortModel[0],
    //   this.state.prevSortModel[0],
    //   sortModel[0]
    // );

    this.setState((prevState) => {
      if (sortModel[0] !== this.state.prevSortModel[0]) {
        return {
          sortModel: sortModel,
          prevSortModel: prevState.sortModel,
        };
      }
    });
  };

  render() {
    if (this.state.isLoading) {
      this.fetch_data();
      return <LoadingBar />;
    }

    return (
      <div style={{ width: "calc(100% - 28px)", padding: 10 }}>
        <Grid container spacing={1} justify="center">
          <Grid item xs={2}>
            <Tabs
              orientation="vertical"
              value={this.state.selected}
              onChange={(e, newValue) => this.setState({ selected: newValue })}
              style={{
                backgroundColor: "white",
                minHeight: "calc(100vh - 84px)",
              }}
            >
              <Tab label="Tabel" index={0}></Tab>
              <Tab label="Prijs per fabrikant" index={1}></Tab>
              <Tab label="Prijs per jaar" index={2}></Tab>
              <Tab label="Hier is iets mis met de prijzen" index={3}></Tab>
            </Tabs>
          </Grid>
          <Grid item xs={9} style={{ maxHeight: "calc(100vh - 74px)" }}>
            <div hidden={this.state.selected !== 0}>Tabel</div>
            <div hidden={this.state.selected !== 1} style={{ height: "100%" }}>
              <ResponsiveContainer
                width={"100%"}
                height={window.innerHeight / 3}
              >
                <BarChart data={this.state.filteredData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  {/* <Bar dataKey="value" fill="#8884d8" /> */}
                  <Bar dataKey="value" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>

              <Paper
                style={{
                  height: "calc(100% - " + window.innerHeight / 3 + "px)",
                }}
              >
                <div style={{ height: "100%", width: "100%" }}>
                  <DataGrid
                    rows={this.rawData}
                    columns={[
                      { field: "id", hide: true },
                      {
                        field: "name",
                        headerName: "Fabrikant naam",
                        width: 200,
                      },
                      {
                        field: "value",
                        headerName: "Uitgegeven (€)",
                        type: "number",
                        width: 200,
                      },
                      {
                        field: "aantal",
                        headerName: "Aantal",
                        type: "number",
                        width: 200,
                      },
                    ]}
                    pageSize={10}
                    checkboxSelection
                    selectionModel={this.state.selectionModel}
                    onSelectionModelChange={this.handleSelectionChange}
                    sortModel={this.state.sortModel}
                    onSortModelChange={this.handleSortChange}
                  />
                </div>
              </Paper>
            </div>
            <div hidden={this.state.selected !== 2} style={{ height: "100%" }}>
              <ResponsiveContainer
                width={"100%"}
                height={window.innerHeight / 3}
              >
                <BarChart data={this.SpendPerYearArray}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="Year" />
                  <YAxis domain={[0, 6000]} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="Total" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>
            </div>

            <div hidden={this.state.selected !== 3}>
              <Grid container>
                {this.ERGINGIETSFOUT.map((item) => (
                  <Grid item xs={2}>
                    {item}
                  </Grid>
                ))}
              </Grid>{" "}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default StatisticalOverview;
